module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-office-tour"
  }, [_c('div', {
    staticClass: "modal-office-tour__bg"
  }, [_c('div', {
    staticClass: "modal-office-tour__container"
  }, [_c('div', {
    staticClass: "modal-office-tour__close",
    on: {
      "click": function($event) {
        _vm.$emit("closeOfficeTourModal")
      }
    }
  }), _c('div', {
    staticClass: "modal-office-tour__body"
  }, [_c('swiper', {
    ref: "swiper",
    staticClass: "modal-office-tour__slider",
    attrs: {
      "options": _vm.swiperOptionTour
    }
  }, _vm._l((_vm.props.gallery), function(image, i) {
    return _c('swiperSlide', {
      key: i,
      staticClass: "modal-office-tour__slide"
    }, [_c('div', {
      staticClass: "modal-office-tour__image",
      style: ("background-image: url(" + image.url + ");")
    })])
  })), _c('div', {
    staticClass: "modal-office-tour__pagination-container"
  }, [_c('div', {
    staticClass: "modal-office-tour__pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })]), _c('div', {
    staticClass: "modal-office-tour__prev-arrow",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('Icon', {
    attrs: {
      "name": "Arrow"
    }
  })], 1), _c('div', {
    staticClass: "modal-office-tour__next-arrow",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('Icon', {
    attrs: {
      "name": "Arrow"
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b466857c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal-office-tour/modal-office-tour.pug
// module id = 596
// module chunks = 1